var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBtnVisible)?_c('b-button',{attrs:{"icon-left":"delete","title":"Supprimer","type":"is-danger","size":"is-small","loading":_vm.deleting,"disabled":_vm.deleting},on:{"click":function($event){return _vm.openConfirmModal()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }